import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { AuthService } from './auth.service';
import { DataService } from './data.service';

export class VisitCardStatus {
    id: string
    code: string
    status: string
    activated_at: String
    from: string
    to: string 
    supplier: string
    updated_at: string
    created_at: string
    data?: any
    backoffice_created?:boolean
    supplierData :{
        id: string,
        type: string,
        slug: string,
        name: string,
        city: string,
        cover: string,
        phone: string,
        email: string,
        website: string,
        logo: string
    }
}

@Injectable({
  providedIn: 'root'
})

export class VisitCardService {
    statusChange = new Subject<void>();

    status:VisitCardStatus = null

    isInitializing = false;
    
    constructor(private authService:AuthService, private dataService:DataService) {
        this.authService.statusChange.subscribe(() => {
            this._loadData();
        })

        this.isInitializing = true;
        
        this._loadData();
    }

    private _loadDataSubscription:Subscription = null;

    private _loadData() {
        if(this._loadDataSubscription != null) this._loadDataSubscription.unsubscribe();

        if(this.authService.isLoggedIn()) {
            this._loadDataSubscription = this.dataService.getRequest('/me/visitCard').subscribe((data) => {
                this._loadDataSubscription = null;

                for(let _item of data) {
                    if(new Date(_item.to).getTime() > Date.now()) {
                        if(this.status == null || this.status.id <= _item.id) {
                            this.status = _item
                        }
                    }
                }

                this.isInitializing = false;
                this.statusChange.next()
            }, () => {
                this._loadDataSubscription = null;
                this.status = null
                this.isInitializing = false;
                this.statusChange.next()
            })
        }
        else {
            this.status = null
            this.isInitializing = false;
            this.statusChange.next()
        }
    }

    activateCode(resource:string, element:string, from:string, to:string) {
        return new Observable<boolean>((observer) => {
            this.dataService.postRequest('/data/visitCard/request', {
                from: new Date(from).toISOString(),
                to: new Date(to).toISOString(),
                supplier: resource + '_' + element
            }).subscribe((data) => {
                this.status = data;
                this.statusChange.next();

                observer.next(true)
                observer.unsubscribe();
            })
        })
    }

    setData(data:any) {
        return new Observable<boolean>((observer) => {
            setTimeout(() => {
                this.status.data = data;

                this.statusChange.next();

                observer.next(true)
                observer.unsubscribe();
            }, 500)
        })
    }

    checkStatus() {
        this._loadData()
    }
}
